import React from 'react';
import { useNavigate } from 'react-router-dom';
import PreferencesSection from '@/components/shared/Account/PreferencesSection';
import './AccountPage.scss';
import UIButton from '@/components/shared/UIButton';

import PersonalInformationSection from '@/components/shared/Account/PersonalnformationSection';
import CompanyInformationSection from '@/components/shared/Account/CompanyInformationSection';
import BillingInformationSection from '@/components/shared/Account/BillingInformationSection';
import GeneralSettingsSection from '@/components/shared/Account/GeneralSettingsSection';
import TwoStepVerificationSection from '@/components/shared/Account/TwoStepVerificationSection';
import ChangePasswordSection from '@/components/shared/Account/ChangePasswordSection';
import SessionAndLoginHistorySection from '@/components/shared/Account/SessionAndLoginHistorySection';
import DocumentsSection from '@/components/shared/Account/DocumentsSection';
import { useDocuments } from '@/hooks/useDocuments';

import UIPageTitle from '@/components/shared/UIPageTitle';

const baseClass = 'AccountPage';

const BackToDashboardButton = () => {
  const navigate = useNavigate();
  return (
    <UIButton
      outline={true}
      variant="primary"
      size="medium"
      onClick={() => navigate('/dashboard')}
    >
      Back to Dashboard
    </UIButton>
  );
};

const AccountPage = () => {
  const navigate = useNavigate();
  const {
    documents,
    loading,
    error,
    onUpload,
    onUpdate,
    onDelete,
  } = useDocuments();

  return (
    <>
      <UIPageTitle
        title="Account"
        action={<BackToDashboardButton />}
      />
      <GeneralSettingsSection />

      <PersonalInformationSection />
      <CompanyInformationSection />
      <BillingInformationSection />
      <DocumentsSection
        documents={documents}
        onUpload={onUpload}
        onUpdate={onUpdate}
        onDelete={onDelete}
        loading={loading}
        error={error}
      />

      <PreferencesSection
        initialValues={{
          language: 'en',
          timeZone: 'gmt+2',
          dateFormat: 'dd/mm/yyyy',
          defaultSetting: 'on',
          options: ['option1', 'option3'],
        }}
        onSave={(values) => console.log('Save:', values)}
        onClear={() => console.log('Clear')}
      />
      <TwoStepVerificationSection />
      <ChangePasswordSection />
      {/*
      <NotificationSettingsSection />
      */}
      <SessionAndLoginHistorySection />

      {/* Кнопки внизу сторінки */}
      <div className={`${baseClass}__bottom-buttons`}>
        <UIButton
          variant="primary"
          outline
          onClick={() => navigate('/dashboard')}
        >
          Back to Dashboard
        </UIButton>

        <UIButton
          variant="danger"
          minWidth={200}
        >
          Delete Account
        </UIButton>
      </div>
    </>
  );
};

export default AccountPage;
